import { useCustomTheme } from 'providers/CustomThemeProvider';
import * as React from 'react';
import {
  NAYYA_END_USER_TERMS_URL,
  NAYYA_PRIVACY_POLICY_URL,
} from 'constants/legal-urls';
import {
  FooterContainer,
  Col,
  FooterInner,
  Text,
  List,
  Item,
  Link,
} from './AuthFooter/styles';

const AuthFooter = (): JSX.Element => {
  const { theme } = useCustomTheme();
  const isUpwise = theme === 'upwise';
  const isNayya = !isUpwise;

  const supportURL = isUpwise
    ? 'https://support.upwise.com/hc/en-us'
    : 'https://support.nayya.com/hc/en-us';

  return (
    <FooterContainer isNayya={isNayya}>
      <Col>
        <FooterInner>
          <Text isNayya={isNayya}>
            © Nayya Health, Inc. All rights reserved.
          </Text>
          <List>
            <Item>
              <Link
                href={NAYYA_PRIVACY_POLICY_URL}
                target="_blank"
                isNayya={isNayya}
              >
                Privacy Policy
              </Link>
            </Item>
            <Item>
              <Link
                href={NAYYA_END_USER_TERMS_URL}
                target="_blank"
                isNayya={isNayya}
              >
                Terms of Service
              </Link>
            </Item>
            <Item>
              <Link href={supportURL} target="_blank" isNayya={isNayya}>
                Help
              </Link>
            </Item>
          </List>
        </FooterInner>
      </Col>
    </FooterContainer>
  );
};

export default AuthFooter;
